module.exports = __webpack_public_path__ + "img/logo-its.72b50ceb.png";